import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-location-related-ticket-popup',
  templateUrl: './location-related-ticket-popup.component.html',
  styleUrls: ['./location-related-ticket-popup.component.css']
})
export class LocationRelatedTicketPopupComponent {

  constructor(
    public dialogRef: MatDialogRef<LocationRelatedTicketPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
